export default __webpack_public_path__ + "6fe056f6cee6e3d47c920e0506b15f68.png";